import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { axiosPatchRequest } from "../../api/ApiClient";
import Dialog from "../../components/Dialog";
import DialogMessage from "../../components/DialogMessage";
import InputTextArea from "../../components/InputTextArea";
import AprovacaoPlanoAtividadeDTO from "../../model/dto/AprovacaoPlanoAtividadeDTO";
import IModalProps from "../../model/ModalProps";
import ButtonStyles from "../../styles/components/ButtonStyles";
import DialogStyles from "../../styles/components/DialogStyles";
import GenericUtils from "../../utils/GenericUtils";
import StringUtils from "../../utils/types/StringUtils";

const { BtnPrimary } = ButtonStyles;
const { StyledModalTitle, StyledContainerButton, StyledModalText } =
    DialogStyles;

interface IModalRequestAdjustmentProps extends IModalProps {
    activityPlanId: number;
}

function ModalRequestAdjustment(props: IModalRequestAdjustmentProps) {
    const { open, activityPlanId, onClose } = props;
    const { instance } = useMsal();
    const acessToken = GenericUtils.getAccessTokenDocente();

    const translate = {
        operationFailure: StringUtils.translate("operationFailure"),
    };

    const [showDialog, setShowDialog] = useState(props.visibility ?? true);
    const [justification, setJustification] = useState("");
    // Dialog
    const [successMessageTitle, setSuccessMessageTitle] = useState("");
    const [successMessageText, setSuccessMessageText] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const isFormValid = Boolean(justification.trim());

    async function statusActivityPlans(dto: AprovacaoPlanoAtividadeDTO) {
        return axiosPatchRequest(
            "/docente/v1/planosatividade/status",
            dto,
            acessToken,
            instance
        );
    }

    const handleSubmit = async () => {
        setShowDialog(false);
        if (isFormValid) {
            const dto: AprovacaoPlanoAtividadeDTO = {
                aprovacao: false,
                justificava: justification,
                planoAtividadeDocenteId: [activityPlanId],
            };

            const response = await statusActivityPlans(dto);

            if (GenericUtils.isSuccessStatus(response.status)) {
                setSuccessMessageTitle("Solicitação enviada");
                setSuccessMessageText(
                    "O professor responsável receberá sua solicitação."
                );
            } else {
                setErrorMessage(
                    response.data?.details || translate.operationFailure
                );
            }
        }
    };

    const handleCloseDialogSuccess = () => {
        setShowDialog(props.visibility ?? true);
        setSuccessMessageTitle("");
        setSuccessMessageText("");
        if (onClose) onClose({ success: true });
    };

    const handleCloseDialogError = () => {
        setErrorMessage("");
        if (onClose) onClose({ success: false });
    };

    useEffect(() => {
        if (!open) {
            setJustification("");
        }
    }, [open]);

    const DialogSuccess = (
        <DialogMessage
            type="success"
            show={Boolean(successMessageTitle)}
            title={successMessageTitle}
            text={successMessageText}
            onClose={handleCloseDialogSuccess}
        />
    );

    const DialogError = (
        <DialogMessage
            type="error"
            show={Boolean(errorMessage)}
            title={errorMessage}
            onClose={handleCloseDialogError}
        />
    );

    const dialogClass = `${showDialog ? "visible-dialog" : "hidden-dialog"}`;

    return (
        <>
            <Dialog
                openModal={open && !successMessageTitle && !errorMessage}
                onHide={onClose}
                className={dialogClass}
                size="width-600"
            >
                <StyledModalTitle style={{ marginBottom: "0" }}>
                    Solicitar ajuste
                </StyledModalTitle>
                <StyledModalText className="mt-4 mb-4">
                    Insira abaixo os ajustes que devem ser realizados
                </StyledModalText>
                <Row>
                    <Col>
                        <InputTextArea
                            label="Justificativa"
                            placeholder="Texto de justicativa para solicitação de ajuste do TACH."
                            maxLength={500}
                            value={justification}
                            onChange={(event: any) =>
                                setJustification(event.target.value as string)
                            }
                            style={{ height: "95px" }}
                        />
                    </Col>
                </Row>
                <StyledContainerButton>
                    <BtnPrimary
                        disabled={!isFormValid}
                        onClick={() => handleSubmit()}
                    >
                        Enviar
                    </BtnPrimary>
                </StyledContainerButton>
            </Dialog>
            {successMessageTitle && DialogSuccess}
            {errorMessage && DialogError}
        </>
    );
}

export default ModalRequestAdjustment;
